// import Funrural from './Index.vue'
import Permissions from "../../models/Permissions";

const Funrural = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Funrural",
  icon: "fa fa-archive",
  group: "Folha",
  permissions,
};

export default [
  {
    path: "/funrural",
    name: "Apuração Funrural",
    component: Funrural,
    meta,
  },
];
